'use client';

import { __module as propTypes } from "../../_virtual/index4.js";
import { __require as requireReactIs } from "./external/react-is/index.js";
import { __require as requireFactoryWithTypeCheckers } from "./factoryWithTypeCheckers.js";
import { __require as requireFactoryWithThrowingShims } from "./factoryWithThrowingShims.js";
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
export {
  requirePropTypes as __require
};
